import React, { useState } from "react";
import dayjs from "dayjs";
import { Col, Row } from "antd";

import classes from "../Filter.module.css";
import { CommonDatePicker } from "../../CommonForms/CommonDatePicker";
import CommonButton from "../../Buttons/CommonButton";
import { FilterValuesCheck } from "../../../Shared/Methods";

interface props {
  showfilter: boolean;
  GetList: (page?: any, size?: any, value?: any) => void;
  pageSize: number;
  ResetForm: () => void;
}

function Filterfailureanalysisreport({
  showfilter,
  GetList,
  pageSize,
  ResetForm,
}: props) {
  const [values, setvalues] = useState<any>({
    fromDatetime: "",
    toDatetime: "",
    forType: "",
  });

  return (
    <>
      {showfilter ? (
        <div className={classes.filter_container}>
          <Row gutter={[16, 16]}>
            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <CommonDatePicker
                labelname="From Date"
                value={values.fromDatetime}
                onChange={(data, dateString) => {
                  setvalues({
                    ...values,
                    fromDatetime: data ? dayjs(data).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                name="fromDatetime"
                FromDate={values.fromDatetime}
                ToDate={values.toDatetime}
                DateType="from_date"
              />
            </Col>

            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <CommonDatePicker
                labelname="To Date"
                value={values.toDatetime}
                onChange={(data, dateString) => {
                  setvalues({
                    ...values,
                    toDatetime: data ? dayjs(data).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                name="toDatetime"
                ToDate={values.toDatetime}
                FromDate={values.fromDatetime}
                DateType="to_date"
              />
            </Col>

            <Col
              xl={6}
              lg={8}
              md={8}
              sm={12}
              xs={24}
              className="d-flex align-items-end"
            >
              <CommonButton
                name="Search"
                onClick={() => {
                  GetList(1, pageSize, {
                    fromDatetime: values.fromDatetime
                      ? dayjs(values.fromDatetime).format("YYYY-MM-DD 23:59:59")
                      : "",
                    toDatetime: values.toDatetime
                      ? dayjs(values.toDatetime).format("YYYY-MM-DD 00:00:00")
                      : "",
                    forType: values.forType || "",
                  });
                }}
                type="Submit"
                classname="submit_btn"
                disabled={FilterValuesCheck(values)}
              />
              &nbsp;&nbsp;
              <CommonButton
                name="Reset"
                onClick={() => {
                  setvalues({
                    fromDatetime: "",
                    toDatetime: "",
                    forType: "",
                  });
                  ResetForm();
                }}
                // style={{ color: "white", backgroundColor: "#0084ff" }}
                classname="reset_btn"
                type="button"
                disabled={FilterValuesCheck(values)}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
}

export default Filterfailureanalysisreport;
